import * as React from 'react';
import sanitizeHTML from 'sanitize-html';
import PropTypes from 'prop-types';

export const safeHTMLConfig = {
  allowedTags: ['b', 'strong', 'i', 'em', 'u', 'p', 'a', 'br', 'ol', 'li', 'ul'],
  allowedAttributes: {
    a: ['href', 'target'],
  },
};

/**
 * Sanitizes and renders HTML within a div.
 * You can pass extra props to customize the container div.
 */
const SanitizeHTML = props => {
  const { sanitizerOptions, html, ...otherProps } = props;

  const sanitizedHTML = sanitizeHTML(html, sanitizerOptions);

  // eslint-disable-next-line react/no-danger
  return <p dangerouslySetInnerHTML={{ __html: sanitizedHTML }} {...otherProps} />;
};

SanitizeHTML.propTypes = {
  html: PropTypes.string.isRequired,
  sanitizerOptions: PropTypes.object,
};

SanitizeHTML.defaultProps = {
  sanitizerOptions: safeHTMLConfig,
};

export default SanitizeHTML;
